import { render, staticRenderFns } from "./ImageUploadWidget.vue?vue&type=template&id=1b869ac4&scoped=true"
import script from "./ImageUploadWidget.vue?vue&type=script&lang=js"
export * from "./ImageUploadWidget.vue?vue&type=script&lang=js"
import style0 from "./ImageUploadWidget.vue?vue&type=style&index=0&id=1b869ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b869ac4",
  null
  
)

export default component.exports